import AppRecord from './AppRecord.js'
import APP from '../../../main.js'
class InvoiceType extends AppRecord {
  get controller_name(){
    return 'InvoiceTypesController'
  }

  readIntervals(){
    const q = {
      q: {
        where: {
          invoice_type_id: this.id
        }
      }
    }
    this.constructor.employeeStore.GET_INVOICE_TYPE_INTERVALS(q)
  }

  get invoice_type_intervals(){
    return this.constructor.employeeStore.invoice_type_intervals.filter(x => x.invoice_type_id == this.id)
  }
}

export default InvoiceType
